import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query getOrganisationalSummary(
    $businessId: ID!
    $category: OrganisationalSummaryCategory
    $teams: [ID]
    $duration: OrganisationalSummaryDuration
    $trendRateDuration: OrganisationalSummaryTrendDuration
    $industry: String
    $companySize: OrganisationalSummaryCompanySizeInput
  ) {
    organisationalSummary(
      businessId: $businessId
      category: $category
      teams: $teams
      duration: $duration
      trendRateDuration: $trendRateDuration
      industry: $industry
      companySize: $companySize
    ) {
      main {
        loginRate {
          value
        }
        engagementRate {
          value
        }
        numberOfEngagedUsers {
          value
        }
        numberOfEngagements {
          value
        }
        savingsGBP {
          value
        }
        savingsPercentage {
          value
        }
        savingsAUD {
          value
        }
        fixedSavingsGBP {
          value
        }
        fixedSavingsAUD {
          value
        }
        estimatedSavingsGBP {
          value
        }
        estimatedSavingsAUD {
          value
        }
        trends {
          date {
            year {
              value
            }
            month {
              value
            }
            quarter {
              value
            }
          }
          numberOfActivatedUsers {
            value
          }
          numberOfEngagedUsers {
            value
          }
          numberOfUsersLoggedIn {
            value
          }
          numberOfEngagements {
            value
          }
          savingsGBP {
            value
          }
          savingsPercentage {
            value
          }
          savingsAUD {
            value
          }
          savings {
            rewardPointsGbp
            rewardPointsAud
            flexiPointsGbp
            flexiPointsAud
            digitalVouchersGbp
            digitalVouchersAud
            estimated {
              discountVouchersGbp
              discountVouchersAud
            }
          }
          industryBenchmark {
            engagementRate {
              value
            }
          }
        }
      }
      perks {
        engagementRate {
          value
        }
        redemptions {
          value
        }
        usersRedeemed {
          value
        }
        savingsGBP {
          value
        }
        savingsPercentage {
          value
        }
        savingsAUD {
          value
        }
        fixedSavingsGBP {
          value
        }
        fixedSavingsAUD {
          value
        }
        estimatedSavingsGBP {
          value
        }
        estimatedSavingsAUD {
          value
        }
        discountVoucherEstimatedSavingsGbp {
          value
        }
        discountVoucherEstimatedSavingsAud {
          value
        }
        digitalVoucherSavingsGbp {
          value
        }
        digitalVoucherSavingsAud {
          value
        }
        trends {
          date {
            year {
              value
            }
            month {
              value
            }
            quarter {
              value
            }
          }
          redemptions {
            value
          }
          usersRedeemed {
            value
          }
          savingsGBP {
            value
          }
          savingsPercentage {
            value
          }
          savingsAUD {
            value
          }
          numberOfActivatedUsers {
            value
          }
          flexiPointsBurned {
            value
          }
          industryBenchmark {
            engagementRate {
              value
            }
          }
        }
      }
      flexi {
        engagementRate {
          value
        }
        redemptions {
          value
        }
        usersRedeemed {
          value
        }
        earned {
          value
        }
        burned {
          value
        }
        savingsGBP {
          value
        }
        savingsAUD {
          value
        }
        trends {
          date {
            year {
              value
            }
            month {
              value
            }
            quarter {
              value
            }
          }
          redemptions {
            value
          }
          usersRedeemed {
            value
          }
          earned {
            value
          }
          burned {
            value
          }
          savingsGBP {
            value
          }
          savingsAUD {
            value
          }
          numberOfActivatedUsers {
            value
          }
          industryBenchmark {
            engagementRate {
              value
            }
          }
        }
      }
      celebrations {
        engagementRate {
          value
        }
        usersEngaged {
          value
        }
        recognitions {
          value
        }
        polls {
          value
        }
        rewardPointsGiven {
          value
        }
        rewardPointsPurchased {
          value
        }
        trends {
          date {
            year {
              value
            }
            month {
              value
            }
            quarter {
              value
            }
          }
          usersEngaged {
            value
          }
          recognitions {
            value
          }
          polls {
            value
          }
          rewardPointsGiven {
            value
          }
          rewardPointsPurchased {
            value
          }
          usersGivenRecognition {
            value
          }
          usersReceivedRecognition {
            value
          }
          numberOfActivatedUsers {
            value
          }
          industryBenchmark {
            engagementRate {
              value
            }
          }
        }
      }
      wellness {
        engagementRate {
          value
        }
        usersEngaged {
          value
        }
        views {
          value
        }
        webinarRegistrations {
          value
        }
        trends {
          date {
            year {
              value
            }
            month {
              value
            }
            quarter {
              value
            }
          }
          usersEngaged {
            value
          }
          views {
            value
          }
          webinarRegistrations {
            value
          }
          numberOfActivatedUsers {
            value
          }
          industryBenchmark {
            engagementRate {
              value
            }
          }
        }
      }
      availableBenchmarks {
        industry
        companySize {
          lower {
            value
          }
          upper {
            value
          }
        }
      }
    }
  }
`

export const organisationalSummaryKey = getQueryNames(query)[0]

export default query
